import React from "react";

const PushNotificationsContext = React.createContext({});

export default PushNotificationsContext;
